import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import * as actions from './actions'
import mutations from './mutations'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        permissionList: [],
        keepAliveComponents: [], // 缓存页面
        operationList: [], // 页面里面的对应的操作权限列表
        imgDomain: '', // 图片域名地址
        bucket_domain_token: '', // 七牛上传token
        loginData: {}, // 登录信息,
        activeIndex: '', // menu展开路径
        areaList: [],
        areaMap: {}
    },
    mutations,
    actions,
    plugins: [createPersistedState({ storage: window.sessionStorage })]
})

export default store
